import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from "./store";
import { Provider } from "react-redux";
import setAuthToken from "./utils/setAuthToken";
import jwt_decode from "jwt-decode";
import { logoutUser, setCurrentUser } from "./actions/authActions";
import {initialState} from "./reducers/_preferenceReducer";
import {loadPreferences, toggleDarkMode} from "./actions/preferenceActions";
import LoggerUtil from "./utils/LoggerUtil";
// Configuration axios (doit être importé avant toute utilisation d'axios)
import './config/axios';

let logger = LoggerUtil('%c[Portfolio]', 'color:#e45447;font-weight:bold;');

// Handle preference
if (localStorage._preference) {
	let lPreference = loadPreferences(JSON.parse(localStorage._preference));
	if (lPreference) {
		store.dispatch(lPreference);
	}
} else {
	localStorage._preference = JSON.stringify(initialState);
}

let hours = (new Date()).getHours();
store.dispatch(toggleDarkMode(hours < 6 || hours > 19))

// Test subscribe
store.subscribe(() => {
	let _state = store.getState();
	if (_state._preferences._dark !== undefined){
		logger.log('Dark mode is -> ' + _state._preferences._dark);
	}
});

// Check for token to keep user logged in
if (localStorage.jwtToken) {
	// Set auth token header auth
	const token = localStorage.jwtToken;
	setAuthToken(token);
	
	// Vérifier le token et récupérer les infos utilisateur
	try {
		// Décoder le token pour vérifier l'expiration
		const tokenWithoutBearer = token.replace('Bearer ', '');
		const decoded = jwt_decode(tokenWithoutBearer);
		
		// Check for expired token
		const currentTime = Date.now() / 1000; // to get in milliseconds
		if (decoded.exp < currentTime) {
			// Logout user si token expiré
			store.dispatch(logoutUser());
		} else {
			// Utiliser les données du token décodé (elles contiennent id, email, role)
			// On peut aussi faire un appel API pour récupérer les données complètes si nécessaire
			store.dispatch(setCurrentUser({
				id: decoded.id,
				email: decoded.email,
				role: decoded.role,
				name: decoded.name
			}));
		}
	} catch (error) {
		// Token invalide, déconnecter
		console.error('Token error:', error);
		store.dispatch(logoutUser());
	}
}

window.APP_NAME = "Portfolio";

// React 18: utiliser createRoot au lieu de ReactDOM.render
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
	<Provider store={store}>
		<HelmetProvider>
			<App />
		</HelmetProvider>
	</Provider>
);

// If you want your app to work offline and load faster, you can change
	// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: [URL]
serviceWorker.unregister();
